module.exports = __webpack_public_path__ + "static/img/file_rtf.96393964.png";